import { Injectable } from '@angular/core';
import { Notification } from '@m4u-angular/base/entities/BaseEntities';
import { BaseService } from '@m4u-angular/base/service/BaseService';

@Injectable()
export class NotificationConfigurationBaseService extends BaseService {

    GetButtons(notification: Notification): any[] {
        return [];
    }
}